module.exports = __webpack_public_path__ + "static/img/aboutbanner3.dcbdf57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutbanner3.jpg
// module id = XK8J
// module chunks = 0